import { Reducer } from "redux";
import { LoginModel, ChangePasswordModel } from "./LoginModels";
import { Location } from 'history';

export enum ActionType {
  SetAuth = "AUTH/SET_AUTH",
  LoginRequest = "AUTH/LOGIN_REQUEST",
  LoginSuccess = "AUTH/LOGIN_SUCCESS",
  LoginStarted = "AUTH/LOGIN_STARTED",
  LoginError = "AUTH/LOGIN_ERROR",
  Logout = "AUTH/LOGOUT",
  LogoutSuccess = "AUTH/LOGOUT_SUCCESS",
  ChangePassword = "AUTH/CHANGE_PASSWORD",
  ChangePasswordSubmit = "AUTH/CHANGE_PASSWORD_SUBMIT",
  ChangePasswordSuccess = "AUTH/CHANGE_PASSWORD_SUCCESS",
  ResetPassword = "AUTH/RESET_PASSWORD"
}

export enum LoginError {
  WrongUserOrPassword = "WrongUserOrPassword"
}

export interface LoginState {
  isLoggingIn: boolean;
  isLoggedIn: boolean;
  companyId: string | null;
  role: string | null;
  token: string | null;
  loginError: LoginError | null;
  userId: string | null;
  passwordChangeRequired: boolean;
}

interface LoginRequestAction {
  type: ActionType.LoginRequest;
  loginData: LoginModel;
  location: Location
}

interface LoginSuccessAction {
  type: ActionType.LoginSuccess
}

interface LoginErrorAction {
  type: ActionType.LoginError;
  error: LoginError;
}

interface LogoutAction {
  type: ActionType.Logout;
};

interface LogoutSuccessAction {
  type: ActionType.LogoutSuccess
}

interface ChangePasswordAction {
  type: ActionType.ChangePassword;
}

interface LoginStartedAction {
  type: ActionType.LoginStarted
}

export interface ResetPasswordAction {
  type: ActionType.ResetPassword,
  userName: string
}

export interface ChangePasswordSubmitAction {
  type: ActionType.ChangePasswordSubmit,
  data: ChangePasswordModel
}

interface ChangePasswordSuccessAction {
  type: ActionType.ChangePasswordSuccess
}

interface SetAuthData {
  company_id: string;
  role: string;
  token: string;
  userId: string;
  passwordChangeRequired: boolean;
}

interface SetAuthAction {
  type: ActionType.SetAuth,
  data: SetAuthData
}

type LoginAction = LogoutSuccessAction | LoginSuccessAction | SetAuthAction | LoginErrorAction | LoginStartedAction | ChangePasswordSuccessAction;

export const actionCreators = {
  loginStarted: () => <LoginStartedAction>{ type: ActionType.LoginStarted },
  loginRequest: (payload: LoginModel, location: Location) => <LoginRequestAction>{ type: ActionType.LoginRequest, loginData: payload, location },
  loginSuccess: () => <LoginSuccessAction>{ type: ActionType.LoginSuccess },
  loginFailed: (error: LoginError) => <LoginErrorAction>{ type: ActionType.LoginError, error },
  logoutSuccess: () => <LogoutSuccessAction>{ type: ActionType.LogoutSuccess },
  logoutRequest: () => <LogoutAction>{ type: ActionType.Logout },
  changePassword: () => <ChangePasswordAction>{ type: ActionType.ChangePassword },
  changePasswordSubmit: (data: ChangePasswordModel) => <ChangePasswordSubmitAction>{ type: ActionType.ChangePasswordSubmit, data },
  changePasswordSuccess: () => <ChangePasswordSuccessAction>{ type: ActionType.ChangePasswordSuccess },
  setAuth: (data: SetAuthData | null) => <SetAuthAction>{ type: ActionType.SetAuth, data },
  resetPassword: ({ userName }: any) => <ResetPasswordAction>{ type: ActionType.ResetPassword, userName }
};

function parseJwt(token: string) {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace('-', '+').replace('_', '/');
  return JSON.parse(window.atob(base64));
};

const initialState = (): LoginState => {
  const token = localStorage.getItem("token");
  

  let jwt;
  if (token) {
    jwt = parseJwt(token);
  }

  return {
    isLoggingIn: false,
    isLoggedIn: jwt != null,
    token: jwt,
    companyId: jwt ? jwt.company_id : null,
    role: jwt ? jwt.role : null,
    loginError: null,
    userId: jwt ? jwt.sub : null,
    passwordChangeRequired: jwt ? jwt.passwordChangeRequired : false
  }
};

export const reducer: Reducer<LoginState> = (state: LoginState, incomingAction: LoginAction) => {
  switch (incomingAction.type) {
    case ActionType.LoginStarted:
      return {
        ...state,
        isLoggingIn: true,
        isLoggedIn: false
      }
    case ActionType.LoginSuccess:
      return {
        ...state,
        isLoggedIn: true,
        isLoggingIn: false,
        loginError: null
      };
    case ActionType.LogoutSuccess:
      return {
        ...state,
        isLoggedIn: false,
        isLoggingIn: false,
        loginError: null
      }
    case ActionType.SetAuth:

      const { data } = incomingAction;
      return {
        ...state,
        token: data ? data.token : null,
        companyId: data ? data.company_id : null,
        role: data ? data.role : null,
        isLoggedIn: data && !!incomingAction.data.token,
        userId: data ? data.userId : null,
        passwordChangeRequired: data ? data.passwordChangeRequired : false
      }
    case ActionType.LoginError:
      return {
        ...state,
        isLoggingIn: false,
        loginError: incomingAction.error
      }
    case ActionType.ChangePasswordSuccess:
      return {
        ...state,
        passwordChangeRequired: false
      }
    default:
      const exhaustiveCheck: never = incomingAction;
  }

  return state || initialState();
};



// WEBPACK FOOTER //
// ./src/login/loginStore.ts